<template>
  <div class="acc-notif-item margin-top-m">
    <div class="large margin-bottom-xs">
      {{ INBOX.rewardsLabel }}
    </div>
    <p class="margin-bottom-s">
      {{ INBOX.enrollRewards.signUpForStarRewards }}
    </p>
    <div class="margin-bottom-m">
      <NotificationsButton :page-url="INBOX.enrollRewards.rewardsPageUrl" :button-label="INBOX.enrollRewards.enrollTodayLabel">
        {{ INBOX.enrollRewards.enrollTodayLabel }}
      </NotificationsButton>
    </div>
  </div>
</template>
<script setup>
import { INBOX } from 'config';
import NotificationsButton from './NotificationsButton';
</script>
